import {File} from "./file";
import {Service} from "./service";
import {Country} from "./country";
import {CustomerSource} from "./customerSource";

export class User {
    id: string;
    username: string;
    password: string;
    email: string;
    phone: string;
    firstName: string;
    lastName: string;
    street: string;
    houseNumber: string;
    flatNumber: string;
    city: string;
    postCode: string;
    country: Country;
    token: string;
    refreshToken: string;
    refreshTokenExpiration: number;
    roles: string[] = [];
    sex: string;
    birthday: string;
    birthdayDay: string;
    birthdayMonth: string;
    birthdayYear: string;
    nameDay: string;
    nameDayDay: string;
    nameDayMonth: string;
    clientSource: CustomerSource;
    createdAt: string;
    description: string;
    documents?: File[];
    services: Service[];
    calendarPriority: number;
    alwaysActiveInCalendar: boolean;
    nip: string;
    companyName: string;
    companyStreet: string;
    companyCity: string;
    companyPostCode: string;
    companyCountry: Country;
    readTheContraindications: boolean;
    readThePriceList: boolean;
    readTheRegulations: boolean;
    gdprAgrees: boolean;
    consentToMarketing: boolean;
    firstTraditionalTransaction: string;
    firstOnlineTransaction: string;
    cardsQuantity: number;
    multiSport: boolean;
    lastMultiSportUse: string;
    canAddFirstTimeVoucher: boolean;
    medicover: boolean;
    medicoverPlus: boolean;
    lastMedicoverUse: string;
    visibleInCalendar?: boolean = false;
    visibleInScheduler: boolean = false;
    pzuSport: boolean;
    lastPzuSportUse: string;
    profit: boolean;
    lastProfitUse: string;
    cardNumber: string;
    cardUuid: string;
}
